var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRacism(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#60636A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_318_",
    className: "st0",
    d: "M95.9,192.4c-12.9,0-25.8,0-38.6,0c-1.5,0-2.5-0.4-3.6-1.5c-17.3-17.4-34.7-34.8-52.1-52.1 c-1.2-1.2-1.6-2.4-1.6-4c0-25.7,0-51.3,0-77c0-1.7,0.5-2.8,1.7-4C19.1,36.6,36.4,19.3,53.6,2c1.2-1.2,2.3-1.6,4-1.6 c25.6,0,51.2,0.1,76.8,0c1.8,0,2.9,0.5,4.2,1.8c17.2,17.3,34.5,34.5,51.7,51.7c1.3,1.2,1.7,2.5,1.7,4.2c0,25.6,0,51.2,0,76.8 c0,1.7-0.5,3-1.7,4.2c-17.3,17.2-34.5,34.5-51.7,51.7c-1.2,1.2-2.3,1.7-4,1.7C121.7,192.3,108.8,192.4,95.9,192.4z M95.9,176.5 c10.6,0,21.1,0,31.7,0c1.8,0,3.1-0.5,4.4-1.8c14.3-14.4,28.6-28.7,42.9-42.9c1-1,1.2-2.1,1.2-3.4c0-12.3,0-24.6,0-37 c0-9.1,0-18.2,0-27.4c0-1.1-0.1-2.1-1-3c-14.6-14.5-29.1-29-43.6-43.6c-1-1-2-1.3-3.4-1.3c-21.4,0-42.9,0-64.3,0 c-1.4,0-2.4,0.4-3.3,1.4C46.1,32,31.7,46.4,17.2,60.8c-1,1-1.4,2-1.4,3.4c0,21.4,0,42.9,0,64.3c0,1.5,0.5,2.5,1.5,3.6 C31.7,146.4,46,160.7,60.3,175c1.1,1.1,2.2,1.6,3.8,1.6C74.7,176.5,85.3,176.5,95.9,176.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_262_",
    className: "st0",
    d: "M51.3,58.8c5.8,5.8,11.5,11.5,17.4,17.4c-2,3.5-1.9,7.2,1.3,10.4c2.3,2.3,5.7,2.4,9.9,0.5 c6.2,5.7,12,12.1,18.5,18.3c-14.8,0.1-25.1,6.3-31.5,19.8c2.6,0,4.8,0.1,7-0.1c0.6,0,1.3-0.8,1.7-1.4c2.7-4.1,6.2-7.3,10.8-9.2 c7.7-3.1,15.1-2.6,22.3,1.6c0.6,0.4,1.2,0.8,1.7,1.3c7.5,7.5,15.1,15,22.6,22.6c0.3,0.3,0.5,0.6,0.7,0.9 c-18.8,17.2-54.1,21-78.5-2.6C33.1,116.8,31.7,81.6,51.3,58.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_259_",
    className: "st0",
    d: "M146.3,126.8c1.9,1.7,3.8,3.5,5.5,5.1c-2.3,2.4-4.4,4.6-6.3,6.6C114.9,108,84.4,77.6,53.6,46.9 c1.9-2,4.1-4.1,6.5-6.5c2,1.9,3.9,3.8,6,5.8c14.2-8,29.2-10.4,45-6.2c11.5,3.1,21.4,8.9,29,18.1C157.3,79.3,158.7,102.2,146.3,126.8 z M139,118.6c8.8-15.3,7.9-39.5-8.2-56.1c-15.3-15.7-39-18.9-57.1-9.2C95.4,75,117.2,96.8,139,118.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_241_",
    className: "st0",
    d: "M116.7,72.8c4.2-0.3,8.1,3.5,8,8c0,4.3-3.6,7.8-8,7.8c-3.9,0-7.7-2.8-7.9-7.9 C108.7,76.4,112.4,72.8,116.7,72.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRacism);
export default __webpack_public_path__ + "static/media/noRacism.be40bde8ebed9f9a5b4ede2f689f754a.svg";
export { ForwardRef as ReactComponent };